import { useState } from "react";
import PageHeader from "@/components/shared/PageHeader";
import LoadingSkeleton from "@/components/shared/LoadingSkeleton";
import ErrorState from "@/components/shared/ErrorState";
import EmptyState from "@/components/shared/EmptyState";
import { useTerritorialInspections } from "@/hooks";
import type { TerritorialInspectionSummary } from "@/types/territorial-inspection";
import PreliminaryDataBanner from "../inspecoes/components/PreliminaryDataBanner";
import InspectionDetailDrawer from "../inspecoes/components/InspectionDetailDrawer";
import QuadrasGrid from "./components/QuadrasGrid";
import SatelliteVegetationSection from "./components/SatelliteVegetationSection";

export default function TerritorioQuadrasPage() {
  const { inspections, loading, error } = useTerritorialInspections();
  const [selected, setSelected] = useState<TerritorialInspectionSummary | null>(null);

  return (
    <div className="space-y-5">
      <PageHeader
        title="Território > Quadras"
        subtitle="Quadras territoriais do Setor Bela Vista com indicadores calculados a partir das inspeções assistidas por IA (FITA v1.0)."
      />

      <SatelliteVegetationSection />

      <PreliminaryDataBanner />

      {loading && <LoadingSkeleton type="table" count={6} />}

      {!loading && error && <ErrorState message="Não foi possível carregar as quadras territoriais." />}

      {!loading && !error && inspections.length === 0 && (
        <EmptyState
          icon="ri-layout-grid-line"
          title="Nenhuma quadra territorial inspecionada ainda"
          description="Importe inspeções territoriais em Território > Inspeções para ver as quadras aqui."
        />
      )}

      {!loading && !error && inspections.length > 0 && (
        <>
          <p className="text-xs text-foreground-500">{inspections.length} quadras territoriais encontradas</p>
          <QuadrasGrid inspections={inspections} onOpen={setSelected} />
        </>
      )}

      <InspectionDetailDrawer
        inspectionCode={selected?.inspectionCode ?? null}
        onClose={() => setSelected(null)}
      />
    </div>
  );
}
